import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Armchair, CalendarDays, ChevronDown, ChevronUp, Contact, HeartHandshake, Home, MessageCircle, MessageCircleMore, PanelLeftOpen, Repeat2, Star, Stethoscope, Send, FileText, FolderSync, TicketCheck, Search, ShieldCheck, Ruler, BookUser, LockKeyhole, BotMessageSquare, CircleArrowOutDownLeft, CircleArrowOutUpRight, AlignJustify, ClipboardList, FileSpreadsheet, TriangleAlert, ClipboardPlus, SquareUser, FileUp } from "lucide-react";
import UserDropdown from "./UserDropdown";
import NotificationDropdown from "./NotificationDropdown";
import { checkUnityEhrCredentials, fetchLocations, getProfileData } from "../../services/profile";
import {
  can_visit,
  clearLocalStorageExcept,
  getSpeciality,
  getSecureData,
  getSecureDataPropertyValue,
  removeSecureItem,
  role_count,
  role_has,
  setSecureData,
  notify
} from "../../helpers";
import { useDispatch } from "react-redux";
import { setUserProfile } from "../../redux/actions";
import { getSMSLimitData, loadMessageTemplate } from "../../services/message";
import { fetchInsuranceAsPractice } from "../../services/patient";
import { getLetterLimitData } from "../../services/letter";
import { fetchAllUserProviders, portalFeatureConfigs } from "../../services/users";
import { Config } from "../../Config";
import { Drawer } from 'vaul';
import { setAccessToken, setFeatureConfigs, setMessageTemplatesData, setPracticeInfo } from "../../Session";
import { logout } from "../../services/login";
import useHighlightEhrMessage from "../../hooks/useHighlightEhrMessage";
import { fetchInsuranceGroup } from "../../services/insurance";
import PresentDateTimeDisplay from "../Section/PresentDateTimeDisplay";

const DocproSidnav = ({ removeMobileActive, toggle, handelToggle }) => {
  const handleMouseEnter = () => {
    document.body.classList.add('docpro_sidebar_collaps_hover'); // Add class on hover
  };
  const handleMouseLeave = () => {
    document.body.classList.remove('docpro_sidebar_collaps_hover'); // Remove class when hover ends
  };

  return (
    <div
      className="docpro_sidnav custom-scroll"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <ul className="docpro_sidnav_list docpro_nav_others">
        <li>
          <NavLink to="/" onClick={() => removeMobileActive()}>
            <span className="docpro_sidenav_item_icon">
              <Home />
            </span>
            <span>Dashboard</span>
          </NavLink>
        </li>
        {(can_visit('_role_trial') || can_visit('audit')) && (
          <li>
            <NavLink to="/audit" onClick={() => removeMobileActive()} className="">
              <span className="docpro_sidenav_item_icon">
                <Ruler />
              </span>
              <span>Audit</span>
            </NavLink>
          </li>
        )}
        {can_visit('waiting_room') && (
          <li>
            <NavLink to="/waiting-room" onClick={() => removeMobileActive()} className="docpro_toor_box1">
              <span className="docpro_sidenav_item_icon">
                <Armchair />
              </span>
              <span>Waiting Room</span>
            </NavLink>
          </li>
          )}
        {can_visit('clinical_notes') && (
          <li>
            <NavLink to="/clinical-notes" onClick={() => removeMobileActive()} className="docpro_toor_box1">
              <span className="docpro_sidenav_item_icon">
                <ClipboardList />
              </span>
              <span>Clinical Notes</span>
            </NavLink>
          </li>
        )}
        {can_visit('appointment') && (
          <li>
            <NavLink to="/appointments" onClick={() => removeMobileActive()} className="">
              <span className="docpro_sidenav_item_icon">
                <CalendarDays />
              </span>
              <span>Appointment</span>
            </NavLink>
          </li>
        )}
        {can_visit('patient_database') && (
          <li>
            <NavLink to="/patient-database" onClick={() => removeMobileActive()} className="docpro_toor_box2">
              <span className="docpro_sidenav_item_icon">
                <Contact />
              </span>
              <span>Patient Database</span>
            </NavLink>
          </li>
        )}
        {can_visit('fidelis_care') && (
          <li>
            <Link
              className={`${toggle === "fidelis" ? "active" : ""} ${can_visit('_role_trial') && "trial"}`}
              onClick={() => handelToggle("fidelis")}
            >
              <span className="docpro_sidenav_item_icon">
                <SquareUser />
              </span>
              <span>Fidelis Care</span>
              <span style={{ marginLeft: 'auto', textAlign: 'end', maxWidth: '20px' }}>
                {toggle === "fidelis" ? 
                  <ChevronUp height={18} width={18} />
                : 
                  <ChevronDown height={18} width={18} />
                }
              </span>
            </Link>
            {toggle === "fidelis" && (
              <ul className="docpro_sidenav_dropdown">
                <li>
                  <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/fidelis-patient'}`} onClick={() => removeMobileActive()} className={`not_main_manue ${can_visit('_role_trial') && 'trial'}`}>Patient List</NavLink>
                </li>
                <li>
                  <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/outgoing-message'}`} onClick={() => removeMobileActive()} className={`not_main_manue ${can_visit('_role_trial') && 'trial'}`}>Outgoing Message</NavLink>
                </li>
                <li>
                  <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/incoming-message'}`} onClick={() => removeMobileActive()} className={`not_main_manue ${can_visit('_role_trial') && 'trial'}`}>Incoming Message</NavLink>
                </li>
              </ul>
            )}
          </li>
        )}
        {can_visit('ccm_database') && (
          <li>
            <NavLink to="/ccm-database" onClick={() => removeMobileActive()} className="docpro_toor_box6">
              <span className="docpro_sidenav_item_icon">
              <BookUser />
              </span>
              <span>CCM Notes</span>
            </NavLink>
          </li>
        )}
        {can_visit('imaging_orders') && (
          <li>
            <NavLink to="/imaging-orders" onClick={() => removeMobileActive()} className="">
              <span className="docpro_sidenav_item_icon">
                <Stethoscope />
              </span>
              <span>Imaging Orders</span>
            </NavLink>
          </li>
        )}
        {can_visit('mips') && (
          <li>
            <NavLink to="/mips" onClick={() => removeMobileActive()} className="">
              <span className="docpro_sidenav_item_icon">
                <FileSpreadsheet />
              </span>
              <span>MIPS</span>
            </NavLink>
          </li>
        )}
        {/* {can_visit('ai_charting') && (
          <li>
            <NavLink to="/ai-charting" onClick={() => removeMobileActive()} className="">
              <span className="docpro_sidenav_item_icon">
                <ClipboardPlus />
              </span>
              <span>AI Charting </span>
            </NavLink>
          </li>
        )} */}

         {can_visit('ai_charting') && (
          <li>
            <NavLink to="/prompt-playground" onClick={() => removeMobileActive()} className="">
              <span className="docpro_sidenav_item_icon">
                <ClipboardPlus />
              </span>
              <span>Prompt Playground</span>
            </NavLink>
          </li>
        )}
        
        {can_visit('caregap_plus') && (
          <li>
            <NavLink to="/caregap-plus" onClick={() => removeMobileActive()} className="docpro_toor_box4">
              <span className="docpro_sidenav_item_icon">
                <HeartHandshake />
              </span>
              <span>CareGap Plus</span>
            </NavLink>
          </li>
        )}
        {can_visit('easy_referral') && (
          // <li>
          //   <NavLink to="/easy-referral" onClick={() => removeMobileActive()} className="">
          //     <span className="docpro_sidenav_item_icon">
          //       <Repeat2 />
          //     </span>
          //     <span>Easy Referral</span>
          //   </NavLink>
          // </li>
          (role_count() > 1 && role_has("Specialist")) ? (
            <li>
              <Link
                className={`${toggle === "referral" ? "active" : ""} ${can_visit('_role_trial') && "trial"}`}
                onClick={() => handelToggle("referral")}
              >
                <span className="docpro_sidenav_item_icon">
                  <Repeat2 />
                </span>
                <span>Easy Referral</span>
                <span style={{ marginLeft: 'auto', textAlign: 'end', maxWidth: '20px' }}>
                  {toggle === "referral" ? 
                    <ChevronUp height={18} width={18} />
                  : 
                    <ChevronDown height={18} width={18} />
                  }
                </span>
              </Link>
              {toggle === "referral" && (
                <ul className="docpro_sidenav_dropdown">
                  {can_visit('easy_referral') && (
                    <li>
                      <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/incoming-referral'}`} onClick={() => removeMobileActive()} className={`not_main_manue ${can_visit('_role_trial') && 'trial'}`}>Incoming Referral</NavLink>
                    </li>
                  )}
                  {can_visit('easy_referral') && (
                    <li>
                      <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/outgoing-referral'}`} onClick={() => removeMobileActive()} className={`not_main_manue ${can_visit('_role_trial') && 'trial'}`}>Outgoing Referral</NavLink>
                    </li>
                  )}
                </ul>
              )}
            </li>
          ) : (
            <>
              <li>
                <NavLink to="/incoming-referral" onClick={() => removeMobileActive()} className="">
                  <span className="docpro_sidenav_item_icon">
                    <CircleArrowOutDownLeft height={22} width={22} />
                  </span>
                  <span>Incoming Referral</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/outgoing-referral" onClick={() => removeMobileActive()} className="">
                  <span className="docpro_sidenav_item_icon">
                    <CircleArrowOutUpRight height={22} width={22} />
                  </span>
                  <span>Outgoing Referral</span>
                </NavLink>
              </li>
            </>
          )
        )}
        {can_visit('rejection_tracker') && (
          <li>
            <NavLink to="/rejection-tracker" onClick={() => removeMobileActive()} className="">
              <span className="docpro_sidenav_item_icon">
                <FolderSync />
              </span>
              <span>Rejection Tracker</span>
            </NavLink>
          </li>
        )}
        {can_visit('review') && (
          <li>
            <NavLink to="/review" onClick={() => removeMobileActive()} className="">
              <span className="docpro_sidenav_item_icon">
                <Star />
              </span>
              <span>Review</span>
            </NavLink>
          </li>
        )}
        {can_visit('shoutbox') && (
          <li>
            <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/shoutbox'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>
              <span className="docpro_sidenav_item_icon">
                <MessageCircleMore />
              </span>
              <span>Shoutbox</span>
            </NavLink>
          </li>
        )}
        {can_visit('password_manager') && (
          <li>
            <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/password-manager'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>
              <span className="docpro_sidenav_item_icon">
                <LockKeyhole />
              </span>
              <span>Password Manager</span>
            </NavLink>
          </li>
        )}
        {(can_visit("settings") && can_visit("settings_scheduler_setup")) && (
          <li>
            <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/text-pilot'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>
              <span className="docpro_sidenav_item_icon">
                <BotMessageSquare />
              </span>
              <span>Text Pilot</span>
            </NavLink>
          </li>
        )}
        {can_visit('practice_data_sync') && (
          <li>
            <Link
              className={`${toggle === "data_sync" ? "active" : ""} ${can_visit('_role_trial') && "trial"}`}
              onClick={() => handelToggle("data_sync")}
            >
              <span className="docpro_sidenav_item_icon">
                <FileUp />
              </span>
              <span>Data Sync</span>
              <span style={{ marginLeft: 'auto', textAlign: 'end', maxWidth: '20px' }}>
                {toggle === "data_sync" ? 
                  <ChevronUp height={18} width={18} />
                : 
                  <ChevronDown height={18} width={18} />
                }
              </span>
            </Link>
            {toggle === "data_sync" && (
              <ul className="docpro_sidenav_dropdown">
                {can_visit('practice_data_sync') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/practice-data-sync'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Practice Data</NavLink>
                  </li>
                )}
                {can_visit('administrator') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/ipa-data-import'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>IPA Data</NavLink>
                  </li>
                )}
              </ul>
            )}
          </li>
        )}
      </ul>

      <ul className="docpro_sidnav_list">
        {can_visit('messages') && (
          <li>
            <Link
              className={`${toggle === "message" ? "active" : ""} ${can_visit('_role_trial') && "trial"}`}
              onClick={() => handelToggle("message")}
            >
              <span className="docpro_sidenav_item_icon">
                <MessageCircle />
              </span>
              <span>Messages</span>
              <span style={{ marginLeft: 'auto', textAlign: 'end', maxWidth: '20px' }}>
                {toggle === "message" ? 
                  <ChevronUp height={18} width={18} />
                : 
                  <ChevronDown height={18} width={18} />
                }
              </span>
            </Link>
            {toggle === "message" && (
              <ul className="docpro_sidenav_dropdown">
                {can_visit('messages_message_transaction') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/bulk-message'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Message Transaction</NavLink>
                  </li>
                )}
                {can_visit('messages_message_templates') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/message-templates'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Message Templates</NavLink>
                  </li>
                )}
                {/* <li>
                  <NavLink to="/website-messages" onClick={() => removeMobileActive()}>Website Messages</NavLink>
                </li> */}
              </ul>
            )}
          </li>
        )}

        {can_visit('letter') && (
          <li>
            <Link
              className={`${toggle === "letter" ? "active" : ""} ${can_visit('_role_trial') && "trial"}`}
              onClick={() => handelToggle("letter")}
            >
              <span className="docpro_sidenav_item_icon">
                <Send />
              </span>
              <span>Letter</span>
              <span style={{ marginLeft: 'auto', textAlign: 'end', maxWidth: '20px' }}>
                {toggle === "letter" ? 
                  <ChevronUp height={18} width={18} />
                : 
                  <ChevronDown height={18} width={18} />
                }
              </span>
            </Link>
            {toggle === "letter" && (
              <ul className="docpro_sidenav_dropdown">
                {can_visit('letter_letter_transaction') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/bulk-letter'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Letter Transaction</NavLink>
                  </li>
                )}
                {can_visit('letter_letter_templates') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/message-templates'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Letter Templates</NavLink>
                  </li>
                )}
              </ul>
            )}
          </li>
        )}

        {can_visit('forms') && (
          <li>
            <Link
              className={`${toggle === "forms" ? "active" : ""} ${can_visit('_role_trial') && "trial"}`}
              onClick={() => handelToggle("forms")}
            >
              <span className="docpro_sidenav_item_icon">
                <FileText />
              </span>
              <span>Forms</span>
              <span style={{ marginLeft: 'auto', textAlign: 'end', maxWidth: '20px' }}>
                {toggle === "forms" ? 
                  <ChevronUp height={18} width={18} />
                : 
                  <ChevronDown height={18} width={18} />
                }
              </span>
            </Link>
            {toggle === "forms" && (
              <ul className="docpro_sidenav_dropdown">
                {can_visit('forms_advanced_directive') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/forms/advanced-directive-form'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Advanced Directive</NavLink>
                  </li>
                )}
                {can_visit('forms_hipaa_consent') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/forms/hipaa-consent-form'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>HIPAA Consent</NavLink>
                  </li>
                )}
                {can_visit('forms_older_care') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/forms/older-care-form'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Older Care</NavLink>
                  </li>
                )}
                {can_visit('forms_patient_intake') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/forms/patient-intake-form'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Patient Intake</NavLink>
                  </li>
                )}
                {can_visit('forms_patient_survey') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/forms/patient-survey-form'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Patient Survey</NavLink>
                  </li>
                )}
                {can_visit('forms_dot_physical') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/forms/dot-physical-form'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>DOT Physical</NavLink>
                  </li>
                )}
                {can_visit('forms_care_plan') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/forms/care-plan-form'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Care Plan</NavLink>
                  </li>
                )}
                {can_visit('forms_community_assessment') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/forms/community-assessment-form'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Community Assessment</NavLink>
                  </li>
                )}
                {can_visit('forms_immunization_form') && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/forms/immunization-form'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Immunization Form</NavLink>
                  </li>
                )}
              </ul>
            )}
          </li>
        )}
      </ul>
      {can_visit('billing') && (
        <ul className="docpro_sidnav_list">
          <li>
            <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/billing'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>
              <span className="docpro_sidenav_item_icon">
                <TicketCheck />
              </span>
              <span>Billing</span>
            </NavLink>
          </li>
        </ul>
      )}
      {can_visit("administrator") && (
        <ul className="docpro_sidnav_list">
          <li>
            <Link
              className={`${toggle === "administrator" ? "active" : ""} ${can_visit('_role_trial') && "trial"}`}
              onClick={() => handelToggle("administrator")}
            >
              <span className="docpro_sidenav_item_icon">
                <ShieldCheck />
              </span>
              <span>Administrator</span>
              <span style={{ marginLeft: 'auto', textAlign: 'end', maxWidth: '20px' }}>
                {toggle === "administrator" ? 
                  <ChevronUp height={18} width={18} />
                : 
                  <ChevronDown height={18} width={18} />
                }
              </span>
            </Link>
            {toggle === "administrator" && (
              <ul className="docpro_sidenav_dropdown">
                {(can_visit("administrator") && can_visit("administrator_onboard_practice")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/onboard-practice'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Onboard Practice</NavLink>
                  </li>
                )}
                {(can_visit("administrator") && can_visit("administrator_onboard_practice")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/onboard-practice-upload-files'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Onboard Files</NavLink>
                  </li>
                )}
                {(can_visit("administrator") && can_visit("administrator_feature_config")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/feature-configs'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Feature Configs</NavLink>
                  </li>
                )}
                {(can_visit("administrator") && can_visit("administrator_permissions")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/practice-permissions'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Permissions</NavLink>
                  </li>
                )}
                {(can_visit("administrator") && can_visit("administrator_roles")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/role-permissions'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Roles</NavLink>
                  </li>
                )}
                {(can_visit("administrator") && can_visit("support_messages")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/support-messages'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Support Messages</NavLink>
                  </li>
                )}
                {(can_visit("administrator") && can_visit("administrator_practice_management")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/practice-management'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Practice Management</NavLink>
                  </li>
                )}
                {(can_visit("administrator") && can_visit("administrator_npi_database")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/npi-database'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>NPI Database</NavLink>
                  </li>
                )}
                {(can_visit("administrator") && can_visit("administrator_insurance_group")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/insurance-groups'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Insurance Groups</NavLink>
                  </li>
                )}
                {(can_visit("administrator") && can_visit("ai_charting_docflow_category")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/docflow-template'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Docflow Template</NavLink>
                  </li>
                )}
                {(can_visit("administrator")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/speciality-prompt'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Speciality Prompt</NavLink>
                  </li>
                )}
                {(can_visit("administrator")) && (
                  <li>
                    <NavLink to={`${can_visit('_role_trial') ? 'trial' : '/eligibility-logs'}`} onClick={() => removeMobileActive()} className={`${can_visit('_role_trial') && 'trial'}`}>Eligibility Logs</NavLink>
                  </li>
                )}
              </ul>
            )}
          </li>
        </ul>
      )}
    </div>
  );
};

export default function Header({setSelectedPracticeChange, setFetchChangePracticeData, smsLimit, setSmsLimit, letterLimit, setLetterLimit, setEnableLoader, selectedPracticeChange, fetchChangePracticeData, setEnablejoyride, setTourType, setChangePracticeSpeciality, setWaitingRoomProviders}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dropdown, setDropdown] = useState(false);
  const [toggle, setToggle] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [profile, setProfile] = useState({});
  const [practice, setPractice] = useState("");
  const [practiceLocation, setPracticeLocation] = useState("");
  const channelRef = useRef(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPractice, setSelectedPractice] = useState(null);
  const [haveNotification, setHaveNotification] = useState(false);
  const dropdownRef = useRef(null);
  const [specialityDropdown, setSpecialityDropdown] = useState(false);
  const [practiceSpeciality, setPracticeSpeciality] = useState([]);
  const [selectedPracticeSpeciality, setSelectedPracticeSpeciality] = useState(null);
  const specialityDropdownRef = useRef(null);
  const [isMoreActive, setIsMoreActive] = useState(false);
  const [drawerPosition, setDrawerPosition] = useState({ top: 0, right: 0 });
  const [notificationHasWs, setNotificationHasWs] = useState(null);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);
  const showEHRMessage = useHighlightEhrMessage();
  const timerRef = useRef(null);
  const IDLE_LIMIT = Config.IdealSessionLogoutTime * 60 * 1000;
  let allPermissions = null;

  const handleLogout = async () => {
    try {
      const response = await logout();
      if(response) {
        await clearLocalStorageExcept();
        navigate("/login", { replace: true });
      }
    } catch (error) {
      console.error("Failed to logout", error);
    }
  };

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      console.log(`%c User has been idle for ${Config.IdealSessionLogoutTime} minutes. Logging out at: ${new Date().toLocaleString()}`, "color:rgb(221, 207, 4)");
      handleLogout();
    }, IDLE_LIMIT);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'mousedown', 'scroll', 'touchstart'];
    events.forEach(e => window.addEventListener(e, resetTimer));
    resetTimer();

    const checkMicActive = async () => {
      let idealUsingMicTime =  await getSecureData("ideal_using_mic_time");
      const currentUnix = Math.floor(Date.now() / 1000);
      const diff = currentUnix - idealUsingMicTime;
      if (diff < 180) {
        resetTimer();
      }
    };

    const micInterval = setInterval(checkMicActive, 5000);

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      clearTimeout(timerRef.current);
      clearInterval(micInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ======::: Practice Info :::
  const [PRACTICE, setPRACTICE] = useState({});
  const fetchPracticeInfo = async () => {
    const data = await getSecureData("practiceInfo");
    setPRACTICE(data);
  };
  useEffect(() => {
    fetchPracticeInfo();
    const observer = new MutationObserver(([mutation]) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "style" &&
        mutation.target === document.body
      ) {
        fetchPracticeInfo();
      }
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["style"],
    });
    return () => observer.disconnect();
  }, []);
  // ======::: End Practice Info :::

  const handelToggle = (toggleItem) => {
    if (toggleItem === toggle) {
      setToggle(false);
    } else {
      setToggle(toggleItem);
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    document.body.classList.toggle("docpro_sidebar_collaps"); // Toggle the class on the body
  };


  const setupUserProfileData = async (data) => {
    if(data?.accounts?.[0]?.practices?.[0]?.account_type === "charting") {
      await clearLocalStorageExcept();
      navigate("/login", { replace: true });
      notify("error", `This account doesn’t have access to the web portal. For assistance, please contact support@doc.pro`, 10);
      return;
    }
    const _practiceInfo = await getSecureData("practiceInfo");
    const _message_templates = await getSecureData("message_templates");
    const _practiceSpecialityInfo = await getSecureData(
      "practiceSpecialityInfo"
    );
    const _redirect = await getSecureData("_redirect");

    const isMatch = data.accounts.some(
      (item) => item?.practices[0]?.account_name === _practiceInfo?.account_name
    );

    if (isMatch) {
      allPermissions = await loadFeatureConfigs(_practiceInfo?.account_id);
      checkNotifications(
        _practiceInfo?.user_id,
        _practiceInfo?.account_id,
        _practiceInfo?.location_id
      );
      setSelectedPractice(_practiceInfo);
      setSelectedPracticeChange(_practiceInfo);
      if (!_message_templates) {
        loadTemplate(_practiceInfo?.account_id);
      }
      if (role_has("Admin")) {
        getWaitingRoomProviders(
          _practiceInfo?.account_id,
          _practiceInfo?.location_id,
          _practiceSpecialityInfo?.id || 32
        );
        setPracticeSpeciality(_practiceInfo?.specialities);
        setSelectedPracticeSpeciality(_practiceSpecialityInfo);
        setChangePracticeSpeciality(_practiceSpecialityInfo);
      } else {
        const adminSpecialities = _practiceInfo?.specialities;
        const userSpecialities = _practiceInfo?.user_speciality;
        const matchedSpecialities = adminSpecialities.filter((adminSpec) =>
          userSpecialities.some((userSpecId) => adminSpec.id === userSpecId)
        );
        getWaitingRoomProviders(
          _practiceInfo?.account_id,
          _practiceInfo?.location_id,
          matchedSpecialities[0]?.id || 32
        );

        setPracticeSpeciality(matchedSpecialities);
        const _ = {
          id: matchedSpecialities[0]?.id,
          name: matchedSpecialities[0]?.name,
        };
        setSelectedPracticeSpeciality(_);
        await setSecureData(
          "practiceSpecialityInfo",
          JSON.stringify(_)
        );
        setChangePracticeSpeciality(_);
      }
      if((typeof _practiceInfo?.baa_agreement !== "string" && !can_visit("administrator")) || (_practiceInfo?.baa_agreement?.trim() === "" && !can_visit("administrator"))) {
        navigate("/baa-agreement", { replace: true });
      }
      await loadInsurance(_practiceInfo?.account_id);
      // setFetchChangePracticeData(true);
    } else {
      allPermissions = await loadFeatureConfigs(data.accounts[0]?.practices[0]?.account_id);
      checkNotifications(
        data?.user_id,
        data.accounts[0]?.practices[0]?.account_id,
        data.accounts[0]?.practices[0]?.location_id
      );
      loadTemplate(data.accounts[0]?.practices[0]?.account_id);
      // xx practiceInfo 2
      const _temp_practiceInfo = {
        user_id: data.user_id,
        is_provider: data?.is_provider,
        account_id: data.accounts[0]?.practices[0]?.account_id,
        account_name: data.accounts[0]?.practices[0]?.account_name,
        location_id: data.accounts[0]?.practices[0]?.location_id,
        location_name: data.accounts[0]?.practices[0]?.name,
        first_name: data?.first_name,
        website: data?.accounts[0]?.practices[0]?.website,
        google_map_place_id: data?.accounts[0]?.practices[0]?.google_map_place_id,
        logo_link: data?.accounts[0]?.practices[0]?.logo_link,
        tour_needed: data.tour_needed,
        user_phone: data?.user_phone,
        practice_email: data?.accounts[0]?.practices[0]?.practice_email,
        specialities: data?.accounts[0]?.practices[0]?.specialities,
        user_speciality: data?.user_speciality_ids,
        ehr_type: data?.ehr_type,
        ehr_username: data?.ehr_username,
        email: data?.email,
        user_name: data?.user_name,
        require_change_password: data?.require_change_password,
        emr_type: data?.accounts[0]?.practices[0]?.emr_type,
        baa_agreement: data?.accounts[0]?.practices[0]?.baa_agreement,
      };


      await setSecureData("practiceInfo", JSON.stringify(_temp_practiceInfo));
      setPRACTICE(_temp_practiceInfo);
      setPracticeInfo(_temp_practiceInfo);

      setSelectedPractice(data.accounts[0]?.practices[0]);
      if (data.accounts[0]?.practices[0]?.specialities?.length > 0) {
        if (role_has("Admin")) {
          getWaitingRoomProviders(
            data.accounts[0]?.practices[0]?.account_id,
            data.accounts[0]?.practices[0]?.location_id,
            data.accounts[0]?.practices[0]?.specialities[0]?.id || 32
          );
          setPracticeSpeciality(data.accounts[0]?.practices[0]?.specialities);

          const _ = {
            id: data.accounts[0]?.practices[0]?.specialities[0]?.id,
            name: data.accounts[0]?.practices[0]?.specialities[0]?.name,
          };
          setSelectedPracticeSpeciality(_);
          await setSecureData(
            "practiceSpecialityInfo",
            JSON.stringify(_)
          );
          setChangePracticeSpeciality(_);
        } else {
          const adminSpecialities =
            data.accounts[0]?.practices[0]?.specialities;
          const userSpecialities = data?.user_speciality_ids;
          const matchedSpecialities = adminSpecialities.filter((adminSpec) =>
            userSpecialities.some((userSpecId) => adminSpec.id === userSpecId)
          );

          getWaitingRoomProviders(
            data.accounts[0]?.practices[0]?.account_id,
            data.accounts[0]?.practices[0]?.location_id,
            matchedSpecialities[0]?.id || 32
          );
          setPracticeSpeciality(matchedSpecialities);
          const _ = {
            id: matchedSpecialities[0]?.id,
            name: matchedSpecialities[0]?.name,
          };
          setSelectedPracticeSpeciality(_);
          await setSecureData(
            "practiceSpecialityInfo",
            JSON.stringify(_)
          );
          setChangePracticeSpeciality(_);
        }
      }
      setSelectedPracticeChange({
        account_id: data.accounts[0]?.practices[0]?.account_id,
        account_name: data.accounts[0]?.practices[0]?.account_name,
        location_id: data.accounts[0]?.practices[0]?.location_id,
        location_name: data.accounts[0]?.practices[0]?.name,
        specialities: data.accounts[0]?.practices[0]?.specialities,
        emr_type: data.accounts[0]?.practices[0]?.emr_type,
      });
      setFetchChangePracticeData(true);

      if (_redirect) {
        navigate(_redirect);
        await removeSecureItem("_redirect");
      }
      if(allPermissions?.ehr_veradigm) {
        await setSecureData("_just_logged_in", true);
      }
      if(data?.require_change_password === true) {
        await setSecureData("_resume_profile_setup", true);
        navigate("/update-password", { replace: true });
        getSMSLimit();
        getLetterLimit();
        return;
      }
      
      if(allPermissions?.ehr_veradigm && (data?.accounts[0]?.practices[0]?.emr_type === "VeradigmEHR")) {
      // if(allPermissions?.ehr_veradigm && data?.is_provider === true && role_has("Specialist")) {
        if((!data?.ehr_type || !data?.ehr_username)) {
          navigate("/connect-veradigm", { replace: true });
        } else {
          const paramsData = {
            "account_id": data.accounts[0]?.practices[0]?.account_id,
            "user_id": data?.user_id,
            "ehr_username": "skip",
            "ehr_password": "skip"
          }
          const res = await checkUnityEhrCredentials(paramsData);
          if(res && res?.data?.status !== "success") {
            notify("error", res?.data?.message, 2);
            navigate("/connect-veradigm", { replace: true });
          }
        }
      }
      if((typeof data?.accounts?.[0]?.practices?.[0]?.baa_agreement !== "string" && !can_visit("administrator")) || (data?.accounts?.[0]?.practices?.[0]?.baa_agreement?.trim() === "" && !can_visit("administrator"))) {
        navigate("/baa-agreement", { replace: true });
      }
      await loadInsurance(data.accounts[0]?.practices[0]?.account_id);
    }
    getSMSLimit();
    getLetterLimit();
  };

  const getProfile = async (callCount = 0) => {
    try {
      const { data } = await getProfileData();
      setProfile(data);
      dispatch(setUserProfile(data));

      if (data?.accounts?.length) {
        await setupUserProfileData(data);
      } else {
        // setTimeout(() => {
        if (data?.accounts?.length) {
          await setupUserProfileData(data);
        } else {
          const accessTokenData = await getSecureData("accessToken");
          if(!accessTokenData || accessTokenData === "") {
            await clearLocalStorageExcept();
            navigate("/login", { replace: true });
          } else {
            setAccessToken(accessTokenData);
            if(callCount === 0) {
              await getProfile(1);
            } else {
              navigate("/no-practices-found", { replace: true });
            }
          }
        }
        // }, 1000);
      }
    } catch (error) {
      /** If user profile api is failing redirect user to login page for re authentication */
      await clearLocalStorageExcept(); // Securely remove token invalidation
      navigate("/login", { replace: true }); // Redirect to login for re-authentication
    }
  };

  const getSMSLimit = async () => {
    if (!can_visit("_role_trial")) {
      const _practiceInfo = await getSecureData("practiceInfo");
      if (_practiceInfo) {
        const result = await getSMSLimitData(_practiceInfo?.account_id);
        if (result) {
          setSmsLimit(result?.data);
        }
      }
    }
  };

  const getLetterLimit = async () => {
    if (!can_visit("_role_trial")) {
      const _practiceInfo = await getSecureData("practiceInfo");
      if (_practiceInfo) {
        const result = await getLetterLimitData(_practiceInfo?.account_id);
        if (result) {
          setLetterLimit(result?.data);
        } else {
          setLetterLimit(0);
        }
      }
    }
  };

  const loadInsurance = async (accounts) => {
    const insuranceParams = {
      account_ids: [accounts]
    }
    const response = await fetchInsuranceAsPractice(insuranceParams);
    // const response = await fetchInsurance();
    if (response) {
      await setSecureData("practice_insurances", JSON.stringify(response.data));
    }
    const responseGroup = await fetchInsuranceGroup();
    if (responseGroup) {
      await setSecureData("practice_insurances_group", JSON.stringify(responseGroup.data));
    }
  };

  const loadPractices = async () => {
    if (profile && profile.accounts) {
      const accounts = profile.accounts;
      const practiceObject = {};
      accounts.forEach(account => {
        account.practices?.forEach(practice => {
          if (practice.account_id && practice.account_name) {
            practiceObject[practice.account_id] = practice.account_name;
          }
        });
      });
      await setSecureData("account_names", JSON.stringify(practiceObject));
    }
  };

  loadPractices()

  // const loadPractices = async () => {
  //   const response = await fetchPractices();

  //   if (response) {
  //     const practicesArray = response.data;

  //     const practiceObject = practicesArray.reduce((prc, practice) => {
  //       prc[practice.id] = practice.practice_name;
  //       return prc;
  //     }, {});

  //     await setSecureData("account_names", JSON.stringify(practiceObject));
  //   }
  // };

  const loadLocations = async () => {
    const response = await fetchLocations();

    if (response) {
      const locationsArray = response.data;

      const locationsObject = locationsArray.reduce((acc, location) => {
        acc[location.id] = location.name;
        return acc;
      }, {});

      await setSecureData("location_names", JSON.stringify(locationsObject));
    }
  };

  const loadTemplate = async (account_id) => {
    if (can_visit("messages_message_templates")) {
      const response = await loadMessageTemplate(account_id);
      if (response) {
        await setSecureData(
          "message_templates",
          JSON.stringify(response.data.results)
        );
        setMessageTemplatesData(response.data.results);
      }
    }
  };

  const loadFeatureConfigs = async (account_id) => {
    try {
      const response = await portalFeatureConfigs(account_id);
      if (response) {
        setFeatureConfigs(response?.data);
        await setSecureData("feature_configs", response?.data);
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  let prevouse_notificationWsURL = null;
  const checkNotifications = (user_id, account_id, location_id) => {
    //need to remove retun after testing    
    let notificationWsURL =
      `${Config.notificationServerUrl}/notifications/ws/has_unread_notification?user_id=${user_id}&account_id=${account_id}&location_id=${location_id}`.replace(
        /^http(s?):/,
        "ws$1:"
      );

    if (
      prevouse_notificationWsURL == notificationWsURL ||
      location_id === undefined
    ) {
      return;
    }
    prevouse_notificationWsURL = notificationWsURL;

    if (notificationHasWs) {
      notificationHasWs.close();
      setNotificationHasWs(null);
    }

    try {
      // if (can_visit("_notifications") && !can_visit("_role_trial")) {
      const notificationWebsocket = new WebSocket(notificationWsURL);
      notificationWebsocket.onmessage = async (event) => {
        // Marked as async
        try {
          const result = JSON.parse(event.data);
          if (result && result.unread_notifications !== undefined) {
            const getLocationId = await getSecureDataPropertyValue(
              "practiceInfo",
              "location_id"
            );
            if (!getLocationId) {
              notificationWebsocket.close();
            }
            setHaveNotification(result.unread_notifications);
          }
        } catch (error) {
          console.error("Error processing message:", error);
        }
      };

      notificationWebsocket.onerror = (error) => {
        console.error("WebSocket error:", error);
      };

      // Optionally handle the close event
      notificationWebsocket.onclose = () => {
        // console.log("WebSocket connection closed.");
      };

      setNotificationHasWs(notificationWebsocket);

      // Returning the WebSocket to allow for manual disconnect
      return notificationWebsocket;
    } catch (error) {
      console.error("Error in notification check:", error);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredAccounts = profile.accounts?.filter((account) => {
    const words = (searchTerm || "").toLowerCase().split(" ").filter(Boolean);

    const includesAll = (text, w) => w.every((x) => text.includes(x));
    const norm = (s) => (s || "").toLowerCase();

    const accountName = norm(account?.practices?.[0]?.account_name);
    const locationNames = (account?.practices || []).map((p) => norm(p?.name));

    if (includesAll(accountName, words)) return true;
    return locationNames.some((ln) => includesAll(ln, words));
  });

  useEffect(() => {
    const fetchData = async () => {
      await getSecureData("practiceInfo");
      try {
        await getProfile();
        const _account_names = await getSecureData("account_names");
        if (!_account_names) {
          await loadPractices();
        }

        const _location_names = await getSecureData("location_names");
        if (!_location_names) {
          await loadLocations();
        }

        setEnableLoader(false);
        const element = document.querySelector(".docpro_nav_others");
        if (!element || !element.textContent.trim()) {
          // Need Change this to check if the location_id is undefined
          // window.location.reload();
        }
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };
    setEnableLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectPractice = async (practice) => {
    allPermissions = await loadFeatureConfigs(practice.account_id);
    const _practice_info = await getSecureData("practiceInfo");
    if (_practice_info) {
      if (_practice_info?.account_id !== practice.account_id) {
        await loadInsurance(practice.account_id);
      }
    } else {
      await loadInsurance(practice.account_id);
    }

    const _temp_practiceInfo = {
      account_id: practice.account_id,
      account_name: practice.account_name,
      location_id: practice.location_id,
      location_name: practice.name,
      first_name: profile?.first_name,
      user_id: profile?.user_id,
      is_provider: profile?.is_provider,
      website: practice?.website,
      google_map_place_id: practice?.google_map_place_id,
      logo_link: practice?.logo_link,
      tour_needed: profile?.tour_needed,
      user_phone: profile?.user_phone,
      practice_email: practice?.practice_email,
      specialities: practice?.specialities,
      user_speciality: profile?.user_speciality_ids,
      ehr_type: profile?.ehr_type,
      ehr_username: profile?.ehr_username,
      email: profile?.email,
      user_name: profile?.user_name,
      require_change_password: profile?.require_change_password,
      emr_type: practice?.emr_type,
      baa_agreement: practice?.baa_agreement,
    };
    await setSecureData("practiceInfo", JSON.stringify(_temp_practiceInfo));
    setPRACTICE(_temp_practiceInfo);
    setPracticeInfo(_temp_practiceInfo);

    setSelectedPractice(practice);
    setSelectedPracticeChange({
      account_id: practice.account_id,
      account_name: practice.account_name,
      location_id: practice.location_id,
      location_name: practice.name,
      specialities: practice?.specialities,
      emr_type: practice?.emr_type,
    });
    setFetchChangePracticeData(true);
    try {
      channelRef.current?.postMessage({
        account_id: practice.account_id,
        account_name: practice.account_name,
        location_id: practice.location_id,
        location_name: practice.name,
      });
    } catch (e) {}
    getSMSLimit();
    getLetterLimit();
    loadTemplate(practice.account_id);
    checkNotifications(
      profile?.user_id,
      practice.account_id,
      practice.location_id
    );

    // checkNotificationsWithWebSocket(
    //   profile?.user_id,
    //   practice.account_id,
    //   practice.location_id
    // );

    if (practice?.specialities?.length > 0) {
      if (role_has("Admin")) {
        getWaitingRoomProviders(
          practice?.account_id,
          practice?.location_id,
          practice?.specialities[0]?.id || 32
        );
        setPracticeSpeciality(practice?.specialities);
        const _ = {
          id: practice?.specialities[0]?.id,
          name: practice?.specialities[0]?.name,
        };
        setChangePracticeSpeciality(_);
        setSelectedPracticeSpeciality(_);
        await setSecureData(
          "practiceSpecialityInfo",
          JSON.stringify(_)
        );
      } else {
        const adminSpecialities = practice?.specialities;
        const userSpecialities = profile?.user_speciality_ids;
        const matchedSpecialities = adminSpecialities.filter((adminSpec) =>
          userSpecialities.some((userSpecId) => adminSpec.id === userSpecId)
        );
        getWaitingRoomProviders(
          practice?.account_id,
          practice?.location_id,
          matchedSpecialities[0]?.id || 32
        );

        setPracticeSpeciality(matchedSpecialities);
        const _ = {
          id: matchedSpecialities[0]?.id,
          name: matchedSpecialities[0]?.name,
        };
        setChangePracticeSpeciality(_);
        setSelectedPracticeSpeciality(_);
        await setSecureData(
          "practiceSpecialityInfo",
          JSON.stringify(_)
        );
      }
    } else {
      setPracticeSpeciality([]);
      setSelectedPracticeSpeciality(null);
      setChangePracticeSpeciality(null);
      await removeSecureItem("practiceSpecialityInfo");
    }
    window.scrollTo(0, previousScrollPosition);
    setDropdown(false);
  };

  const handleSelectPracticeSpeciality = async (specility) => {
    const _practiceInfo = await getSecureData("practiceInfo");
    getWaitingRoomProviders(
      _practiceInfo?.account_id,
      _practiceInfo?.location_id,
      specility?.id
    );
    const _ = {
      id: specility?.id,
      name: specility?.name,
    };
    setChangePracticeSpeciality(_);
    setSelectedPracticeSpeciality(_);

    await setSecureData(
      "practiceSpecialityInfo",
      JSON.stringify(_)
    );
    setSpecialityDropdown(false);
  };

  const getWaitingRoomProviders = async ( accountId, locationId, specilityId ) => {
    try {
      if (allPermissions?.ehr_veradigm || can_visit('ehr_veradigm')) {
        specilityId = 32;
      }
      const response = await fetchAllUserProviders(accountId, locationId, specilityId);
      if (response?.data) {
        setWaitingRoomProviders(response?.data);
      }
    } catch (error) {
      // console.log("🚀 ~ getWaitingRoomProviders: ~ error:", error);
    }
  };

  useEffect(() => {
    const ch = new BroadcastChannel("tab_practice_change");
    channelRef.current = ch;

    ch.onmessage = (event) => {
      setPractice(event?.data?.account_name);
      setPracticeLocation(event?.data?.location_name);
    };

    return () => {
      try { ch.close(); } catch {}
      channelRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeMobileActive = () => {
    window.scrollTo(0, previousScrollPosition);
    setIsMoreActive(false);
  };

  const calculateMoreDrawerPosition = () => {
    const triggerElement = document.querySelector(".mobile_more");
    if (triggerElement) {
      const rect = triggerElement.getBoundingClientRect();
      setDrawerPosition({
        top: rect.bottom + window.scrollY,
        right: window.innerWidth - rect.right,
      });
    }
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  const removePracticeDrawerPosition = () => {
    window.scrollTo(0, previousScrollPosition);
    setDropdown(!dropdown);
  };

  const calculatePracticeDrawerPosition = () => {
    const triggerElement = document.querySelector(".select_practice");
    if (triggerElement) {
      const rect = triggerElement.getBoundingClientRect();
      setDrawerPosition({
        top: rect.bottom + window.scrollY,
      });
    }
    // setPreviousScrollPosition(window.scrollY);
    // window.scrollTo(0, 0);
  };

  const removeSpecialityDrawerPosition = () => {
    window.scrollTo(0, previousScrollPosition);
    setSpecialityDropdown(!specialityDropdown);
  };

  const calculateSpecialityDrawerPosition = () => {
    const triggerSpeciality = document.querySelector(".btn_speciality");
    if (triggerSpeciality) {
      const rect = triggerSpeciality.getBoundingClientRect();
      setDrawerPosition({
        top: rect.bottom + window.scrollY,
      });
      setSpecialityDropdown(!specialityDropdown);
    }
    // setPreviousScrollPosition(window.scrollY);
    // window.scrollTo(0, 0);
  };

  const LimitText = ({ text, limit }) => {
    if (text.length <= limit) {
      return text;
    } else {
      const limitText = text.substring(0, limit) + "...";
      return limitText;
    }
  };

  useEffect(() => {
    const get_practiceInfoData = async () => {
      // const _get_practiceInfo = await getSecureData("practiceInfo");
      if (PRACTICE) {
        checkNotifications(
          PRACTICE?.user_id,
          PRACTICE?.account_id,
          PRACTICE?.location_id
        );
        // setPracticeInfoV(_get_practiceInfo);
      }
    };
    get_practiceInfoData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = () => {
    navigate("/profile");
  };

  return (
    <>
      <style>
        {`.trial, .trial .docpro_sidenav_item_icon {
          pointer-events: none;
          color: #b8b8b8;
          font-weight: 400;
        }`}
      </style>

      <header className="docpro_header">
        <div className="docpro_header_left">          
          <div className="docpro_logos">
            <Link to="/" className="logo_img">
              <img
                src={`${Config.appUrl}/images/logo.svg`}
                alt="Logo"
                className="docpro_logo_img_toggle_1"
              />
              <img
                src={`${Config.appUrl}/images/favicon.png`}
                alt="Logo"
                className="docpro_logo_img_toggle_2"
              />
            </Link>
            <div className="flex items-center small_border">
              {can_visit("_role_enterprise") ? (
                <div className="docpro_badge docpro_badge_green">
                  Enterprise
                </div>
              ) : (
                <div className={`docpro_dropdown_wrap`} ref={dropdownRef}>
                  <Drawer.Root 
                    open={dropdown} 
                    onOpenChange={setDropdown} 
                    onclose={removePracticeDrawerPosition}
                  >
                    <Drawer.Trigger
                      className="docpro_btn docpro_fs_15 select_practice"
                      onClick={calculatePracticeDrawerPosition}
                    >
                      {selectedPractice ? (
                        <p
                          className="docpro_mb_0"
                          style={{
                            display: "grid",
                            textAlign: "left",
                            lineHeight: "normal",
                          }}
                        >
                          <span className="docpro_fw_700">
                            <LimitText
                              text={`${
                                practice !== ""
                                  ? practice
                                  : PRACTICE
                                  ? PRACTICE?.account_name
                                  : "Practice"
                              }`}
                              limit={18}
                            />
                          </span>
                          <span className="docpro_fw_400 docpro_fs_14">
                            <LimitText
                              text={`${
                                practiceLocation !== ""
                                  ? practiceLocation
                                  : PRACTICE
                                  ? PRACTICE?.location_name
                                  : "Location"
                              }`}
                              limit={22}
                            />
                          </span>
                        </p>
                      ) : (
                        "Select Practice"
                      )}
                      <ChevronDown width={20} height={20} />
                    </Drawer.Trigger>
                    <Drawer.Portal>
                      <Drawer.Overlay className="docpro_drawer_overlay" />
                      <Drawer.Content
                        className="docpro_drawer_content docpro_drawer_style_2"
                        style={{ top: drawerPosition.top }}
                      >
                        <Drawer.Title className="sr-only">
                          Practice Menu
                        </Drawer.Title>
                        <Drawer.Description className="sr-only">
                          A menu for the user to change practice.
                        </Drawer.Description>
                        <ul className="docpro_body custom-scroll">
                          {can_visit("administrator") && (
                            <div style={{ padding: "0px 1px 8px 8px" }}>
                              <div className="docpro_search_form w-full">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  className="docpro_search_input"
                                  autoFocus
                                  value={searchTerm}
                                  onChange={handleSearchChange}
                                  style={{
                                    height: "34px",
                                    paddingLeft: "35px",
                                    borderRadius: "5px",
                                  }}
                                />
                                <button
                                  type="button"
                                  className="docpro_search_btn"
                                  style={{ height: "34px", width: "34px" }}
                                >
                                  <Search width={18} height={18} />
                                </button>
                              </div>
                            </div>
                          )}
                          {filteredAccounts?.length > 0 ? (
                            filteredAccounts?.map((item, index) => (
                              <li key={index}>
                                <span className="practice_name">
                                  {item?.practices[0]?.account_name}
                                </span>
                                <div style={{ paddingLeft: "15px" }}>
                                  {item?.practices?.map((practice) => (
                                    <span
                                      key={practice?.location_id}
                                      onClick={() =>
                                        handleSelectPractice(practice)
                                      }
                                      className={`${
                                        can_visit("administrator") &&
                                        (PRACTICE && PRACTICE.location_id) ===
                                          practice.location_id &&
                                        "active"
                                      }`}
                                    >
                                      - {practice?.name}
                                    </span>
                                  ))}
                                </div>
                              </li>
                            ))
                          ) : (
                            <div>
                              <span>No accounts found</span>
                            </div>
                          )}
                        </ul>
                      </Drawer.Content>
                    </Drawer.Portal>
                  </Drawer.Root>
                </div>
              )}
              {((practiceSpeciality?.length > 0) && !can_visit('ehr_veradigm')) && (
                <div
                  className={`docpro_dropdown_wrap spaciality`}
                  ref={specialityDropdownRef}
                >
                  <Drawer.Root
                    open={specialityDropdown}
                    onOpenChange={setSpecialityDropdown}
                    onclose={removeSpecialityDrawerPosition}
                  >
                    <Drawer.Trigger
                      className="docpro_btn docpro_fs_15 btn_speciality"
                      onClick={calculateSpecialityDrawerPosition}
                    >
                      {selectedPracticeSpeciality ? (
                        <p
                          className="docpro_mb_0"
                          style={{
                            display: "grid",
                            textAlign: "left",
                            lineHeight: "normal",
                          }}
                        >
                          <span className="docpro_fw_700">Speciality</span>
                          <span className="docpro_fw_400 docpro_fs_14">
                            <LimitText
                              text={`${
                                selectedPracticeSpeciality?.name !== ""
                                  ? selectedPracticeSpeciality?.name
                                  : getSpeciality()
                                  ? getSpeciality()?.name
                                  : ""
                              }`}
                              limit={16}
                            />
                          </span>
                        </p>
                      ) : (
                        "Select Speciality"
                      )}
                      <ChevronDown width={20} height={20} />
                    </Drawer.Trigger>
                    <Drawer.Portal>
                      <Drawer.Overlay className="docpro_drawer_overlay" />
                      <Drawer.Content
                        className="docpro_drawer_content docpro_drawer_style_5"
                        style={{ top: drawerPosition.top }}
                      >
                        <Drawer.Title className="sr-only">
                          Speciality Menu
                        </Drawer.Title>
                        <Drawer.Description className="sr-only">
                          A menu for the user to change speciality.
                        </Drawer.Description>
                        <ul className="docpro_body custom-scroll">
                          {practiceSpeciality?.map((item, index) => (
                            <li key={index}>
                              <span
                                onClick={() =>
                                  handleSelectPracticeSpeciality(item)
                                }
                              >
                                {item?.name}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </Drawer.Content>
                    </Drawer.Portal>
                  </Drawer.Root>
                </div>
              )}
              {can_visit('ehr_veradigm') && (
                <div className="docpro_dropdown_wrap spaciality">
                  <div className="docpro_fs_15 btn_speciality">
                    <p className="docpro_mb_0" style={{ display: "grid", textAlign: "left", lineHeight: "normal" }}>
                      <span className="docpro_fw_700">EHR ID</span>
                      <span className="docpro_fw_400 docpro_fs_14 docpro_text_uppercase">
                        {profile?.ehr_username ? (
                          <LimitText
                            text={profile?.ehr_username}
                            limit={16}
                          />
                        ) : (
                          <span className="docpro_red_color">—</span>
                        )}
                      </span>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="docpro_header_right flex items-center">
          {showEHRMessage && role_has("Specialist") && !role_has("Admin") && can_visit('ehr_veradigm') && !profile?.ehr_username && !profile?.ehr_type && (
            <div className="docpro_profile_ehr_warning">
              <p className="relative">
                <TriangleAlert width={16} height={16} />
                <span className="docpro_tip">Please complete your EHR profile</span>
                <span className="docpro_profile_ehr_text"> Click 
                  <span style={{ color: "blue", cursor: "pointer", margin: "0 4px" }}
                    onClick={handleClick}
                  >
                    here
                  </span>
                  to update your EHR credentials. 
                </span>
              </p>
            </div>
          )}
          {/* <div className="mr-2 relative message_header_tooltip">
            <span className="docpro_badge docpro_badge_indigo sms_limit_box py-1">
              Letter: {letterLimit?.available_credit ? letterLimit?.available_credit : 0}
            </span>
            <span className="docpro_tip">Available Letter Credit</span>
          </div>
          <div className="mr-2 relative message_header_tooltip">
            <span className="docpro_badge docpro_badge_indigo sms_limit_box py-1">
              SMS: {smsLimit?.available_credit ? smsLimit?.available_credit : 0}
            </span>
            <span className="docpro_tip">Available Message Credit</span>
          </div> */}
          {can_visit("_notifications") && (
            <NotificationDropdown
              profile={profile}
              selectedPracticeChange={selectedPracticeChange}
              fetchChangePracticeData={fetchChangePracticeData}
              haveNotification={haveNotification}
            />
          )}
          <UserDropdown
            profile={profile}
            setEnablejoyride={setEnablejoyride}
            setTourType={setTourType}
          />
        </div>
      </header>
        
      <div className="docpro_sidnav_wrap">
        <DocproSidnav
          removeMobileActive={removeMobileActive}
          toggle={toggle}
          handelToggle={handelToggle}
        />
        <button className="docpro_sidenav_toggle_btn" onClick={toggleSidebar}>
          <PanelLeftOpen />
        </button>
        <PresentDateTimeDisplay />
      </div>

      <div style={{ position: "relative" }} ref={dropdownRef}>
        <Drawer.Root open={isMoreActive} onOpenChange={setIsMoreActive} onclose={removeMobileActive}>
          <div className="docpro_mobile_nav_ios">
            <div className="docpro_mobile_nav">
              <NavLink to="/" className="docpro_mobile_nav_item">
                <span className="docpro_mobile_nav_icon">
                  <Home />
                </span>
                <span>Dashboard</span>
              </NavLink>
              {can_visit("waiting_room") && (
                <NavLink to="/waiting-room" className="docpro_mobile_nav_item">
                  <span className="docpro_mobile_nav_icon">
                    <Armchair />
                  </span>
                  <span>Waiting room</span>
                </NavLink>
              )}
              {can_visit("clinical_notes") && (
                <NavLink to="/clinical-notes" className="docpro_mobile_nav_item">
                  <span className="docpro_mobile_nav_icon">
                    <ClipboardList />
                  </span>
                  <span>Clinical Notes</span>
                </NavLink>
              )}
              {/* <NavLink to="/ai-charting" className="docpro_mobile_nav_item">
                <span className="docpro_mobile_nav_icon">
                  <ClipboardPlus />
                </span>
                <span>AI Charting </span>
              </NavLink> */}
              {/* {can_visit("appointment") && (
                <NavLink to="/appointments" className="docpro_mobile_nav_item">
                  <span className="docpro_mobile_nav_icon">
                    <CalendarDays />
                  </span>
                  <span>Appointment</span>
                </NavLink>
              )} */}
              {can_visit("patient_database") && (
                <NavLink
                  to="/patient-database"
                  className="docpro_mobile_nav_item"
                >
                  <span className="docpro_mobile_nav_icon">
                    <Contact />
                  </span>
                  <span>Patient List</span>
                </NavLink>
              )}
              <Drawer.Trigger className="docpro_mobile_nav_item mobile_more"
                onClick={calculateMoreDrawerPosition}
              >
                <span className="docpro_sidenav_item_icon">
                  <AlignJustify />
                </span>
                <span>More</span>
              </Drawer.Trigger>
            </div>
            <div className="docpro_ios_bottom_bar"></div>
          </div>
          <Drawer.Portal>
            <Drawer.Overlay className="docpro_drawer_overlay" />
            <Drawer.Content
              className="docpro_drawer_content"
              style={{
                top: drawerPosition.top,
                right: drawerPosition.right,
                position: "absolute",
              }}
            >
              <Drawer.Title className="sr-only">Sidebar Menu</Drawer.Title>
              <Drawer.Description className="sr-only">
                A menu for the user to view portal.
              </Drawer.Description>

              <div className="docpro_drawer_content_in">
                <DocproSidnav
                  removeMobileActive={removeMobileActive}
                  toggle={toggle}
                  handelToggle={handelToggle}
                />
              </div>
            </Drawer.Content>
          </Drawer.Portal>
        </Drawer.Root>
      </div>
    </>
  );
}
